import { hideError } from '../../redux/slices/error';
import { RootState } from '../../redux/store';
import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

/**
 * @heading1: ErrorModal
 *
 * @paragraph: A reusable modal component for displaying error messages.
 * The error details, such as the title and description, are fetched from the Redux store.
 */
const ErrorModal = () => {
    /**
     * @heading3: Variables
     * @ol:
     * disaptch: {AppDisptach} - The Redux dispatch function to trigger actions such as hiding the error.
     * error: An object containing the error details from the Redux store. **title(string)** **show(boolean)?** **description(string)**
     * style: CSS-in-JS styling for the modal container.
     */
    const dispatch = useDispatch();
    const error = useSelector((state: RootState) => state.error);


    useEffect(() => {
        if (error.show && !toast.isActive('error-toast')) {
            toast.error(error.description, {
                position: 'top-left',
                autoClose: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                closeButton: true,
                toastId: 'error-toast',
                theme: 'dark',
                onClose: () => {
                    dispatch(hideError());
                    // toast.dismiss();
                }
            });
        }
    }, [error.show, error.description, dispatch]);

    /**
     * @heading3: Functions
     * @heading4: Handles closing the error modal by dispatching the `hideError` action.
     * @code:
     * handleClose();
     */
    // const handleClose = () => {
    //     dispatch(hideError());
    // };

    // return <Modal
    //     open={error.show}
    //     onClose={handleClose}
    //     aria-labelledby="modal-modal-title"
    //     aria-describedby="modal-modal-description"
    // >
    //     <Box sx={style} display="flex" flexDirection="column" alignItems="center">
    //         {/* Error Icon */}
    //         <HighlightOffRoundedIcon sx={{ color: '#EC6566', height: '40px', width: 'auto' }} />
    //         {/* Error Message */}
    //         <Typography
    //             lineHeight="2.25rem"
    //             fontWeight="500"
    //             fontSize="1.3rem"
    //             margin="5px 0"
    //             variant="h5"
    //             color="#EC6566"
    //             textAlign="center"
    //         >
    //             {error.description}
    //         </Typography>
    //         {/* Additional features like a close button can be added here */}
    //         {/* <Typography
    //             fontWeight="400"
    //             fontSize="1rem"
    //             lineHeight="1.375rem"
    //             color="var(--secondary-color)"
    //             textAlign="center"
    //             margin="0 0 0 0"
    //         >{error.description}</Typography> */}
    //         {/* <CustomButton
    //             sx={{
    //                 maxWidth: "fit-content",
    //                 mb: 2,
    //                 mt: 2,
    //                 px: 4,
    //                 backgroundColor: "#4D596C !important",
    //             }}
    //             onClick={handleClose}
    //         >
    //             Close
    //         </CustomButton> */}
    //     </Box>
    // </Modal>;
    return <ToastContainer />;
};

export default ErrorModal;